module.exports = __webpack_public_path__ + "img/icon-02.5e657457.png";